// Sharing helpers: native share sheet (with image file), download, copy link.

async function fetchFile(imageUrl, filename) {
  const res = await fetch(imageUrl);
  const blob = await res.blob();
  return new File([blob], filename, { type: blob.type || "image/png" });
}

export async function shareCard(imageUrl, { title, text, url, filename = "civichearth.png" }) {
  try {
    const file = await fetchFile(imageUrl, filename);
    if (navigator.canShare && navigator.canShare({ files: [file] })) {
      await navigator.share({ files: [file], title, text, url });
      return "shared";
    }
    if (navigator.share) {
      await navigator.share({ title, text, url });
      return "shared";
    }
  } catch (e) {
    if (e && e.name === "AbortError") return "cancelled";
  }
  return "unsupported";
}

export async function downloadCard(imageUrl, filename = "civichearth-card.png") {
  const file = await fetchFile(imageUrl, filename);
  const href = URL.createObjectURL(file);
  const a = document.createElement("a");
  a.href = href;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(href);
}

export async function copyLink(url) {
  try {
    await navigator.clipboard.writeText(url);
    return true;
  } catch {
    return false;
  }
}

// Phase 17-C item 6 — WhatsApp-first sharing. v1 is entirely link-based
// (wa.me deep link, no WhatsApp API): the recipient's app renders the
// unfurl from the shared page's OG meta (api.shareUrl pages).
export function waShareUrl(text) {
  return `https://wa.me/?text=${encodeURIComponent(text)}`;
}

export function openWhatsApp(text) {
  window.open(waShareUrl(text), "_blank", "noopener,noreferrer");
}
